// import http from '../utils/http';
import axios from 'axios';
// import i18n from '@/main';

const baseUrl = '/rastreabilidade/transferencia-interna';

export default {
    async uploadSpreadsheet(file) {
        const formData = new FormData();
        formData.append('file', file);
        const url = process.env.VUE_APP_HTTP_PATH + baseUrl + '/inserir-lote';

        return axios.post(url, formData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
    }
};
